import { render, staticRenderFns } from "./ImportFormItem.vue?vue&type=template&id=3335af66&scoped=true&"
import script from "./ImportFormItem.vue?vue&type=script&lang=js&"
export * from "./ImportFormItem.vue?vue&type=script&lang=js&"
import style0 from "./ImportFormItem.vue?vue&type=style&index=0&id=3335af66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3335af66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3335af66')) {
      api.createRecord('3335af66', component.options)
    } else {
      api.reload('3335af66', component.options)
    }
    module.hot.accept("./ImportFormItem.vue?vue&type=template&id=3335af66&scoped=true&", function () {
      api.rerender('3335af66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ImportFormItem.vue"
export default component.exports